module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "700"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "color": "#0098E1",
            "dark": ""
          }
        }, on), [_c('v-icon', {
          staticClass: "p-right"
        }, [_vm._v("access_time")]), _vm._v("\n        " + _vm._s(_vm.$t("TimeFilter.capitalizedFrom")) + ": " + _vm._s(_vm.fromDateLocaleString) + " " + _vm._s(_vm.$t("TimeFilter.capitalizedTo")) + ": " + _vm._s(_vm.toDateLocaleString) + "\n      ")], 1), _vm._v(" "), _c('v-btn', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "text": "",
            "icon": "",
            "color": "#0098E1"
          },
          on: {
            "click": _vm.refreshTime
          }
        }, [_c('v-icon', [_vm._v("cached")])], 1)]
      }
    }]),
    model: {
      value: (_vm.timeSelectorDialog),
      callback: function($$v) {
        _vm.timeSelectorDialog = $$v
      },
      expression: "timeSelectorDialog"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-card', {
    staticClass: "time-filter-modal"
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t("TimeFilter.customRange")))])]), _vm._v(" "), _c('v-subheader', [_c('b', [_vm._v(_vm._s(_vm.$t("TimeFilter.from")))])]), _vm._v(" "), _c('v-container', {
    staticClass: "date-time-flex"
  }, [_c('div', {
    staticClass: "date-time-selectors"
  }, [_c('v-icon', {
    attrs: {
      "color": "#0098E1"
    }
  }, [_vm._v("\n                access_time\n              ")]), _vm._v(" "), _c('datetime', {
    staticClass: "theme-ponce",
    attrs: {
      "type": "time",
      "format": "hh:mm a",
      "use12-hour": ""
    },
    model: {
      value: (_vm.fromDateString),
      callback: function($$v) {
        _vm.fromDateString = $$v
      },
      expression: "fromDateString"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "date-time-selectors"
  }, [_c('v-icon', {
    attrs: {
      "color": "#0098E1"
    }
  }, [_vm._v("\n                event\n              ")]), _vm._v(" "), _c('datetime', {
    staticClass: "theme-ponce",
    attrs: {
      "type": "date",
      "value-zone": "local",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.fromDateString),
      callback: function($$v) {
        _vm.fromDateString = $$v
      },
      expression: "fromDateString"
    }
  })], 1)]), _vm._v(" "), _c('v-subheader', [_c('b', [_vm._v(_vm._s(_vm.$t("TimeFilter.to")))])]), _vm._v(" "), _c('v-container', {
    staticClass: "date-time-flex"
  }, [_c('div', {
    staticClass: "date-time-selectors"
  }, [_c('v-icon', {
    attrs: {
      "color": "#0098E1"
    }
  }, [_vm._v("\n                access_time\n              ")]), _vm._v(" "), _c('datetime', {
    staticClass: "theme-ponce",
    attrs: {
      "type": "time",
      "format": "hh:mm a",
      "use12-hour": ""
    },
    model: {
      value: (_vm.toDateString),
      callback: function($$v) {
        _vm.toDateString = $$v
      },
      expression: "toDateString"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "date-time-selectors"
  }, [_c('v-icon', {
    attrs: {
      "color": "#0098E1"
    }
  }, [_vm._v("\n                event\n              ")]), _vm._v(" "), _c('datetime', {
    staticClass: "theme-ponce",
    attrs: {
      "type": "date",
      "value-zone": "local",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.toDateString),
      callback: function($$v) {
        _vm.toDateString = $$v
      },
      expression: "toDateString"
    }
  })], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.onApply
    }
  }, [_vm._v(_vm._s(_vm.$t("TimeFilter.customRange")))])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "time-filter-modal"
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t("TimeFilter.quickSelection")))])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "time-filter-modal"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.onQuickSelect('oneHour', _vm.$ponceConfig.timerTypes['diffHours'])
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("TimeFilter.lastHour")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.onQuickSelect('sixHours', _vm.$ponceConfig.timerTypes['diffHours'])
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("TimeFilter.lastSixHours")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.onQuickSelect('oneDay', _vm.$ponceConfig.timerTypes['diffHours'])
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("TimeFilter.lastTwentyFourHours")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.onQuickSelect('twoDays', _vm.$ponceConfig.timerTypes['diffHours'])
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("TimeFilter.lastFortyEightHours")))])], 1), _vm._v(" "), _c('div', {
    staticClass: "time-filter-modal"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.onQuickSelect('oneWeek', _vm.$ponceConfig.timerTypes['diffHours'])
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("TimeFilter.lastSevenDays")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.onQuickSelect('twoWeeks', _vm.$ponceConfig.timerTypes['diffHours'])
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("TimeFilter.lastFourteenDays")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.onQuickSelect('thisWeek', _vm.$ponceConfig.timerTypes['setWeek'])
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("TimeFilter.thisWeek")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.onQuickSelect('thisMonth', _vm.$ponceConfig.timerTypes['setMonth'])
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("TimeFilter.thisMonth")))])], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f43c58be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/TimeFilter.vue
// module id = 1753
// module chunks = 0